<!--  -->
<template>
	<div class="app-container">
		<!-- 1.顶部 -->
		<div class="topCard">
			<img src="../assets/xjj-logo.png" />
		</div>
		<div class="topCard2">
			<img src="../assets//app/7.png" />
			
		</div>

		<!-- 2.输入框 -->
		<div style="padding: 0 20px">
			<div class="inputCard">
				上分 下分 请登陆游戏后点击 在线客服 咨询处理。<br>您实际的用户名会自动加上lx2_
				</div>
			<div class="inputCard">
				<div>账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户：</div>
				<input type="text" style="height: 25px; width: 70%" placeholder="用户名，请使用字母或数字 会自动加上lx2_" v-model="account" />
			</div>
			<div class="inputCard">
				<div>密&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码：</div>
				<input type="password" style="height: 25px; width: 70%" placeholder="密码，须6-12位字母和数字"
					v-model="passwordOne" />
			</div>
		</div>
		<!-- 3.注册按钮 -->
		<div style="text-align: center; margin: 10px 30px">
			<button class="submitBtn" @click="gotoLoginGame">确定登陆腾龙平台</button>
		</div>
	</div>
</template>

<script>
	import {
		LoginGame
	} from "../network/apiFunc";
	import {
		encryptDES,
		MD5_JS
	} from "../util/secret.js";
	// import md5 from "js-md5";
	export default {
		data() {
			return {
				// 账户-密码
				account: "",
				passwordOne: "",
				passwordTwo: "",

				// 邀请码-上级代理编号
				invitationCode: "",

				// 固定的
				key: "zzi$i@@2",
				agentId: "1027773",
				md5key: "=74rdt#)",
				pcloginUrl: "https://www.itl246.com/pch5/",
				loginUrl: "https://www.itl246.com/h5/"
			};
		},

		methods: {
			login() {
				// window.location.href = 'https://www.itl0066.com/'
				//跳转至https://www.itl0066.com//
				window.open('https://www.itl246.com/H5/', '_blank','noopener,noreferrer');
				// window.open('https://www.baidu.com', '_blank');
			},
			loginhn() {
				// window.location.href = 'https://www.itl0066.com/'
				//跳转至https://www.itl0066.com//
				window.open('https://www.586568.com/', '_blank','noopener,noreferrer');
				// window.open('https://www.baidu.com', '_blank');
			},
			gotoLoginGame() {
					var data =
						`{"account":"${this.account}","pwd":"${this.passwordOne}","actype":"1","dm":"${this.loginUrl}","md5key":"${this.md5key}"}`;
					var encryption = encryptDES(data, this.key);
					var md5Value = MD5_JS(encryption);
					if (this.account.length > 0) {
						if (this.passwordOne.length > 0) {
							LoginGame({
								sign: md5Value,
								data: encryption,
								agentId: 237944,
							}).then((res) => {
								console.log(res.data.errorCode);
			
								if (res.data.errorCode == 0) {
									alert("登陆成功！如果遇到打不开网页请多刷新尝试。");
									window.open(res.data.result.gameurl, '_blank','noopener,noreferrer');									
								} else {
									alert(res.data.errorMessage);
								}
			
							});
						} else {
							alert("密码不能为空");
						}
					} else {
						alert("用户名不能为空");
					}
				}
				},
		created() {
			// 获取当前页面的URL
			let url = window.location.href;
			// 解析URL，提取参数值
			let params = new URL(url).searchParams;
			this.account = params.get("account");
			this.passwordOne = params.get("passwordOne");
			
			// 输出pid的值
			console.log(this.account); // 在这个例子中，输出为 "888888"
			//this.invitationCode = pid;
		},
	};
</script>
<style scoped>
	.loginBtn {
		/* width: 100%;
		padding: 15px 0;
		background-color: #d19d58;
		border: none;
		font-weight: bold; */
		
		display: inline-block;
		width: 100%;
		height: 62px;
		border-radius: 3px;
		background: url("../assets/top-2.jpg") no-repeat center center;
		background-size: cover;
		background-position: center;
		margin-right: 10px;
		font-size: 18px;
		color: #fde685;
		line-height: 62px;
		text-align: center;
		margin-top: 20px;
	}
.loginBtn1 {
		/* width: 100%;
		padding: 15px 0;
		background-color: #d19d58;
		border: none;
		font-weight: bold; */
		
		display: inline-block;
		width: 100%;
		height: 62px;
		border-radius: 3px;
		background: url("../assets/top-3.jpg") no-repeat center center;
		background-size: cover;
		background-position: center;
		margin-right: 10px;
		font-size: 18px;
		color: #fde685;
		line-height: 62px;
		text-align: center;
		margin-top: 20px;
	}

	.submitBtn {
		/* width: 100%;
		padding: 8px 0;
		background-color: #d19d58;
		border: none;
		font-weight: bold; */
		
		display: inline-block;
		width: 100%;
		height: 42px;
		border-radius: 3px;
		background: url("../assets/top-3.jpg") no-repeat center center;
		background-size: cover;
		background-position: center;
		margin-right: 10px;
		font-size: 18px;
		color: #fde685;
		line-height: 42px;
		text-align: center;
		/* margin-top: 50px; */
	}

	.inputCard>input {
		border: 1px solid #c39c68;
		/* flex: 0 1 40%; */

		padding: 5px;
	}

	.inputCard {
		color: #c39c68;
		font-weight: bold;
		text-align: center;
		display: flex;
		justify-content: center;
		margin: 10px 0;

		/* border: 1px solid tomato; */

		display: flex;
		align-items: center;
	}

	.topCard {
		background-image: url("../assets//app/6.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		height: 100px;
		display: flex;
		justify-content: center;
		padding: 20px 0;
	}
.topCard2 {
		/* background-image: url("../assets//app/6.png"); */
		background-size: 100% 100%;
		background-repeat: no-repeat;
		height: 100px;
		display: flex;
		justify-content: center;
		margin-top: -30px;
		/* padding: 50px 0; */
	}
	.menuRight {
		/* background-image: url("../assets/web/login02.png"); */
		width: 100%;
		height: 200px;
		background-repeat: no-repeat;
		color: #e5d485;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		background-color: #780206;
	}

	.menuItem {
		color: white;
		/* 居中 */
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px 0;
		width: 100%;

	}

	.app-container {
		background: #780206;
		/* fallback for old browsers */
		background: -webkit-linear-gradient(to right,
				#061161,
				#780206);
		/* Chrome 10-25, Safari 5.1-6 */
		background: linear-gradient(to right,
				#061161,
				#780206);
		/* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
		height: 100%;
	}
</style>